module.exports = __webpack_public_path__ + "606ba060f55e52d17e3d9033498fb824.svg";